// Wire DTO normalization is additive: unknown entity/voice fields survive.
const id = (value) => String(value?._id || value || "");
export const messageKey = (message) => `${message?.type === "call" ? "call" : "message"}:${id(message?._id)}`;
export const normalizeMessage = (message, chatId) => message ? ({
    ...message,
    _id: id(message._id),
    chatId: id(message.chatId || chatId),
    type: message.type === "call" ? "call" : "message",
}) : message;

export const compareMessages = (a, b) => {
    const time = new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime();
    if (time) return time;
    const aId = id(a._id), bId = id(b._id);
    if (aId !== bId) return aId < bId ? -1 : 1;
    const aType = a.type === "call" ? "call" : "message";
    const bType = b.type === "call" ? "call" : "message";
    return aType === bType ? 0 : aType < bType ? -1 : 1;
};

const mergeOne = (current, incoming, preserveCurrent = false) => {
    if (!current) return incoming;
    const newerCurrent = new Date(current.updatedAt || 0).getTime() > new Date(incoming.updatedAt || 0).getTime();
    const merged = preserveCurrent || newerCurrent
        ? { ...incoming, ...current }
        : { ...current, ...incoming };
    // Read membership only grows in the existing contract, including when an
    // unversioned messagesRead event arrived while REST was outstanding.
    merged.readBy = [...new Set([...(current.readBy || []), ...(incoming.readBy || [])].map(id).filter(Boolean))];
    return merged;
};

export const mergeMessages = (current = [], incoming = [], options = {}) => {
    const { append = true, nextCursor = null, changed = {}, deleted = {}, readUsers = [] } = options;
    const incomingItems = incoming.filter(Boolean).map((item) => normalizeMessage(item));
    const oldest = incomingItems.length ? incomingItems.slice().sort(compareMessages)[0] : null;
    const incomingKeys = new Set(incomingItems.map(messageKey));
    const map = new Map();
    for (const item of current) {
        const key = messageKey(item);
        const pending = item.__sendStatus === "sending" || item.__sendStatus === "failed";
        // A refreshed latest page owns only its returned window. Keep loaded
        // older pages and every locally changed item since this GET started.
        if (append || pending || changed[key] || incomingKeys.has(key) ||
            (nextCursor && oldest && compareMessages(item, oldest) < 0)) map.set(key, item);
    }
    for (const incomingItem of incomingItems) {
        const key = messageKey(incomingItem);
        const item = mergeOne(map.get(key), incomingItem, !!changed[key]);
        if (item.type !== "call" && readUsers.length) {
            item.readBy = [...new Set([...(item.readBy || []).map(id), ...readUsers.filter((user) => user !== id(item.sender))])];
        }
        map.set(key, item);
    }
    return [...map.values()].filter((item) => !item.isDeleted &&
        !(item.type !== "call" && deleted[id(item._id)])).sort(compareMessages);
};
